import $ from 'jquery';

var projectMenu = function() {

  const projectMenuBtn = $('.project-nav__title');

  function projectMenu(val) {

    if ($(val).hasClass('print-title')) {
      $('.print-title').addClass('active');
      $('.design-title').removeClass('active');
    } else {
      $('.design-title').addClass('active');
      $('.print-title').removeClass('active');
    }

    $('.project-nav').addClass('translate-up');

    //------------------------------
    //Helper funciton
    //------------------------------
    $.wait = function (ms) {
        var defer = $.Deferred();
        setTimeout(function () { defer.resolve(); }, ms);
        return defer;
    };
  }

  projectMenuBtn.click(function (e) {
      e.preventDefault();
      projectMenu(this);
  });

}

module.exports = projectMenu;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/project-menu.js